<mat-list-item class="mat-list-item-container minMainCls agPardNote" [attr.agid]="minAttrList.agendaId" id="minMainId{{minAttrList.noteId}}" [attr.entityType]="minAttrList.entityType" [attr.minId]="minAttrList.noteId">
    <!-- <div class="example-custom-placeholder" *cdkDragPlaceholder></div> -->
    <div class="container-fluid" [ngStyle]="{'padding':'0px'}">
        <div class="row d-flex item-container">
             <div class="d-flex col-12 col-md-8 col-xl-10 justify-content-start padding-0">
                <!-- <div class="column-one"> -->
                <mat-icon *ngIf="hideParts == false" class="drag-indicator-icon list-icon mat-margin-3px mt-9">
                    drag_indicator</mat-icon>
                <!-- </div> -->
                <!-- <div id = "border-container"> -->
                <button class="global-icn-bttn-container mat-margin-3px" mat-mini-fab tooltip="Notes" placement="right"
                    triggers="hover">
                    <mat-icon class="global-icn-size notes">notes</mat-icon>
                </button>
                <!-- </div> -->
                <!-- <div class="column-two"> -->
                    <ng-template #tooltipTmpl>
                        {{minAttrList.createdByName}} 
                     </ng-template>
                     <ng-template #tooltipTmpl1>
                        {{minAttrList.createdByName}} <br />Updated By: {{minAttrList.lastModifiedName}}<br />{{minAttrList.lastModifiedOn | utcDateConverter }}
                     </ng-template>
                <button *ngIf="hideParts == false" class="mat-margin-3px global-icn-bttn-normal-container"
                    color="primary" mat-mini-fab color="primary" [tooltip] = "minAttrList.lastModifiedName?tooltipTmpl1:tooltipTmpl"
                    placement="right" triggers="hover">{{minAttrList.shortName}}</button>
                <!-- </div> -->
                <div class="col-8 col-md-10 d-flex align-items-center">
                    <ng-container
                        *ngIf="minAttrList.rowStatus!=undefined && minAttrList.rowStatus != null && minAttrList.rowStatus != ''; then nonEditableNote else editableNote">
                    </ng-container>
                    <ng-template #editableNote>
                        <div joyrideStep="meetNoteOneStep" *ngIf="proteanHtml==undefined || proteanHtml==null"
                            text="{{sideNavService.returnTourStatusChecker() == 'instant' ? meetingTourValues.meetNoteOneStep : sideNavService.returnTourStatusChecker() == 'schedule_meeting' ? scheduleMeetingTourValues.meetNoteOneStep : sideNavService.returnTourStatusChecker() == 'past' ? pastMeetingTourValues.meetNoteOneStep : ''}}"
                            class="col column-content notes-content body-font-size mat-margin-3px minComCls" [ngStyle]="{'white-space':'normal'}"
                            (mousedown)="$event.stopPropagation()">
                             <!-- <quill-editor
                              [(ngModel)]="minAttrList.noteDescription"
                              [modules]="quillModules"
                              (onEditorCreated)="onQuillEditorReady($event)"
                              (onSelectionChanged)="onQuillSelectionChanged($event)"
                              (onFocus)="onQuillFocus()"
                              (onBlur)="onQuillBlur()"
                            >
                            </quill-editor>  -->

                            <app-adc-editor
                              class="single-line"
                              [content]="minAttrList.noteDescription"
                              [config]="editorConfig"
                              (editorReady)="onQuillEditorReady($event)"
                              (onSelectionChanged)="onQuillSelectionChanged($event)"
                              (onFocus)="onQuillFocus()"
                              (onBlur)="onQuillBlur()"
                              #adcEditor>
                            </app-adc-editor>

                        </div><br>
                        <div *ngIf="proteanHtml!=undefined&&proteanHtml!=null">
                         <div id="agMinIdWidget{{minAttrList.noteId}}" [ngStyle]="{'display':'block'}"
                         [innerHtml]="proteanHtml"></div>
                        <button (click)="saveContent($event)" *ngIf="hideSaveButton">save</button>
                        </div>
                        <div *ngIf="proteanHtml!=undefined&&proteanHtml!=null">
                         <mat-form-field>
                                    <mat-label class="label-font body-font-size">User Response</mat-label>
                                    <mat-select panelClass="common-drop-down-class" (selectionChange)="viewUserResponse($event)" [(ngModel)]="selectedUser"  class="body-font-size">
                                        <ng-container>
                                            <mat-option class="body-font-size"
                                                *ngFor="let attendee of rightsList" [value]="attendee.fkSecUserAttendee+''">{{attendee.attendeeName}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                        </div>
                    </ng-template>
                    <ng-template #nonEditableNote>
                        <div
                            class="col column-content notes-content body-font-size mat-margin-3px minComCls" [ngStyle]="{'white-space':'normal'}">
                            <app-adc-editor
                              class="single-line"
                              [readOnly]="true"
                              [(ngModel)]="minAttrList.noteDescription"
                              [config]="editorConfig"
                              (editorReady)="onQuillEditorReady($event)">
                            </app-adc-editor>
                        </div>
                    </ng-template>
                    <!-- <span id="note-tooltip" aria-hidden="true">User is typing</span> -->
                    <!-- <div class="collab-section">{{minAttrList.rowStatus}}</div> -->
                    <div class="collab-section">{{minAttrList.rowStatus}}</div>
                </div>
                <!-- <div class="col-lg-1" class = "collab-section">
                    User is typing...
                </div> -->
            </div>
            <div class="d-flex col-15 col-md-4 col-xl-2 justify-content-end flex-wrap" [ngStyle]="{'padding-right':'0px'}">

                <!-- <button [disabled]="disableNotesIcon" *ngIf="contentEditableBoolmin"
                    text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    mat-icon-button [matMenuTriggerFor]="agAttachMenu" tooltip="History" placement="left" triggers="hover"
                    class="mat-margin-3px global-icn-bttn-container disableAfterApprove">
                    <mat-icon class="global-icn-size mat-margin-3px">history</mat-icon>
                </button> -->



                <button [disabled]="disableNotesIcon" *ngIf="contentEditableBoolmin"
                    text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    mat-icon-button [matMenuTriggerFor]="agAttachMenu" tooltip="Add" placement="left" triggers="hover"
                    class="mat-margin-3px global-icn-bttn-container disableAfterApprove">
                    <mat-icon class="global-icn-size mat-margin-3px">add</mat-icon>
                </button>
                <!-- <button  class="mat-margin-3px global-icn-bttn-container" (click)="getAllProteanForm()"><mat-icon class="global-icn-size mat-margin-3px">view_compact</mat-icon>
                </button> -->
                <mat-menu #agAttachMenu="matMenu">

                    <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item (click)="createEmptyAgenda($event)" [attr.agId]="minAttrList.agendaId">
                        <mat-icon class="mat-icon-menu"  [attr.agId]="minAttrList.agendaId"> list_alt</mat-icon>
                        add agenda
                    </button>
                    <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item [attr.agId]="minAttrList.agendaId" [attr.minId]="minAttrList.noteId"
                        id="agMinId{{minAttrList.noteId}}" [attr.noteId]="minAttrList.noteId"
                        [attr.entityType]="minAttrList.entityType" [attr.isPrivate]="isPrivate"
                        [attr.agId]="minAttrList.agendaId" (click)="createEmptyNote($event)">
                        <mat-icon class="mat-icon-menu" [attr.agId]="minAttrList.agendaId" [attr.minId]="minAttrList.noteId"
                        id="agMinId{{minAttrList.noteId}}" [attr.noteId]="minAttrList.noteId"
                        [attr.entityType]="minAttrList.entityType" [attr.isPrivate]="isPrivate"
                        [attr.agId]="minAttrList.agendaId">notes</mat-icon>
                        add note
                    </button>

                    <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item [attr.agId]="minAttrList.agendaId" [attr.minId]="minAttrList.noteId"
                        id="agMinId{{minAttrList.noteId}}" [attr.noteId]="minAttrList.noteId"
                        [attr.entityType]="minAttrList.entityType" [attr.isPrivate]="isPrivate"
                        [attr.agId]="minAttrList.agendaId" (click)="createEmptyTask($event)">
                        <mat-icon class="mat-icon-menu" [attr.agId]="minAttrList.agendaId" [attr.minId]="minAttrList.noteId"
                        id="agMinId{{minAttrList.noteId}}" [attr.noteId]="minAttrList.noteId"
                        [attr.entityType]="minAttrList.entityType" [attr.isPrivate]="isPrivate"
                        [attr.agId]="minAttrList.agendaId">assignment</mat-icon>
                        add task
                    </button>

                    <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item [attr.agId]="minAttrList.agendaId" [attr.minId]="minAttrList.noteId"
                        id="agMinId{{minAttrList.noteId}}" [attr.noteId]="minAttrList.noteId"
                        [attr.entityType]="minAttrList.entityType" [attr.isPrivate]="isPrivate"
                        [attr.agId]="minAttrList.agendaId" (click)="createEmptyDecision($event)">
                        <mat-icon class="mat-icon-menu" [attr.agId]="minAttrList.agendaId" [attr.minId]="minAttrList.noteId"
                        id="agMinId{{minAttrList.noteId}}" [attr.noteId]="minAttrList.noteId"
                        [attr.entityType]="minAttrList.entityType" [attr.isPrivate]="isPrivate"
                        [attr.agId]="minAttrList.agendaId">thumb_up</mat-icon>
                        add decision
                    </button>

                    <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item (click)="createEmptyAgenda($event)" [attr.agId]="minAttrList.agendaId" [attr.parentAgId]="minAttrList.agendaId">
                        <mat-icon class="mat-icon-menu"  [attr.agId]="minAttrList.agendaId"> list_alt</mat-icon>
                        add sub topic
                    </button>
                    <!-- <button mat-menu-item (click)="attachService.uploadFromFileSys(agList,'AG')">
                        <mat-icon>file_upload</mat-icon>
                        <span>Upload from file system</span>
                    </button>
                    <button mat-menu-item>
                        <mat-icon>add_link</mat-icon>
                        <span>Add Link</span>
                    </button> -->
                </mat-menu>
                <button [disabled]="disableNotesIcon || padlockDisable"
                    *ngIf="(pinDialogTriggered == false && videoSectionStatusChecker) && hideParts == false && (deviceXl || deviceLg) && contentEditableBoolmin"
                    tooltip="Private" placement="left" triggers="hover" class="mat-margin-3px global-icn-bttn-container disableAfterApprove"
                    mat-mini-fab (click)="togglePadLock($event)">
                    <mat-icon class="global-icn-size mat-margin-3px" [ngStyle]="(padlock)? {'color' : 'red'} : {}">
                        {{(padlock)? 'lock' : 'lock_open'}}</mat-icon>
                </button>
                <button [disabled]="disableNotesIcon" joyrideStep="meetNoteTwoStep"
                    text="{{sideNavService.returnTourStatusChecker() == 'instant' ? meetingTourValues.meetNoteTwoStep : sideNavService.returnTourStatusChecker() == 'schedule_meeting' ? scheduleMeetingTourValues.meetNoteTwoStep : sideNavService.returnTourStatusChecker() == 'past' ? pastMeetingTourValues.meetNoteTwoStep : ''}}"
                    *ngIf="(pinDialogTriggered == false && videoSectionStatusChecker) && hideParts == false  && (deviceXl || deviceLg) && minAttrList.attachmentTotalCnt == 0 && attachmentIcon == 'Y'"
                    mat-icon-button tooltip="Attachment" triggers="hover" placement="left" (click) = "getMinComStatusCode()"
                    [matMenuTriggerFor]="attachmenu" class="mat-margin-3px global-icn-bttn-container">
                    <mat-icon class="global-icn-size attachment mat-margin-3px">attachment</mat-icon>
                </button>
                <button [disabled]="disableNotesIcon" joyrideStep="meetNoteTwoStep"
                    text="{{sideNavService.returnTourStatusChecker() == 'instant' ? meetingTourValues.meetNoteTwoStep : sideNavService.returnTourStatusChecker() == 'schedule_meeting' ? scheduleMeetingTourValues.meetNoteTwoStep : sideNavService.returnTourStatusChecker() == 'past' ? pastMeetingTourValues.meetNoteTwoStep : ''}}"
                    *ngIf="(pinDialogTriggered == false && videoSectionStatusChecker) && hideParts == false  && (deviceXl || deviceLg) && minAttrList.attachmentTotalCnt >0 || attachmentIcon == 'N'"
                    mat-icon-button tooltip="Attachment" triggers="hover" placement="left" (click) = "getMinComStatusCode()"
                    [matMenuTriggerFor]="attachmenu" class="mat-margin-3px global-icn-bttn-container">
                    <mat-icon matBadge="{{ minAttrList.attachmentTotalCnt }}" matBadgeSize="medium"
                        class="global-icn-size attachment mat-margin-3px">attachment</mat-icon>
                </button>
                <mat-menu #attachmenu="matMenu">
                    <button class="body-font-size d-flex align-items-center menu-btn-alignment" mat-menu-item (focus)="getAttachCount(minAttrList)"
                        (click)="openConfidentialDialog(minAttrList,minAttrList.entityType)" >
                        <mat-icon class="mat-icon-menu"
                            matBadge="{{attachCount ? minAttrList.attachmentFileCount  : agendaAttachResp.attachmentFileCount}}"
                            matBadgeSize="medium" matBadgeColor="accent">file_upload</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">view / add file</h3>
                    </button>
                    <button class="body-font-size d-flex align-items-center menu-btn-alignment" mat-menu-item (click)="addNewLink(minAttrList.noteId,minAttrList.meetingId)">
                        <mat-icon class="mat-icon-menu"
                            matBadge="{{attachCount ? minAttrList.attachmentLinkCount  : agendaAttachResp.attachmentLinkCount}}"
                            matBadgeSize="medium" matBadgeColor="accent">add_link</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">view / add link</h3>
                    </button>
                </mat-menu>
                <button [disabled]="disableNotesIcon" tooltip="More" joyrideStep="meetNoteThreeStep"
                    text="{{sideNavService.returnTourStatusChecker() == 'instant' ? meetingTourValues.meetNoteThreeStep : sideNavService.returnTourStatusChecker() == 'schedule_meeting' ? scheduleMeetingTourValues.meetNoteThreeStep : sideNavService.returnTourStatusChecker() == 'past' ? pastMeetingTourValues.meetNoteThreeStep : ''}}"
                    placement="left" triggers="hover"
                    class="mat-margin-3px global-icn-bttn-container disableAfterApprove" mat-mini-fab
                    [matMenuTriggerFor]="minMenu">
                    <mat-icon class="global-icn-size mat-margin-3px">more_vert</mat-icon>
                </button>
                <mat-menu #minMenu="matMenu">
                    
                        <button mat-menu-item (click)="openLinkToTaskDialog()">
                          <mat-icon>link</mat-icon>
                          <span>Link to Task</span>
                        </button>
                    <button *ngIf="contentEditableBoolmin" mat-menu-item class="body-font-size d-flex align-items-center menu-btn-alignment"
                        (click)="commonMinService.removeMinutesFromHover('minMainId'+minAttrList.noteId,null)">
                        <mat-icon class="mat-icon-menu">delete</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">delete</h3>
                    </button>
                    <button *ngIf="contentEditableBoolmin" mat-menu-item class="body-font-size d-flex align-items-center menu-btn-alignment"
                        (click)="history(minAttrList.noteId,minAttrList.lastModifiedName)">
                        <mat-icon class="mat-icon-menu">history</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">history</h3>
                    </button>
                    <button
                        *ngIf="(pinDialogTriggered == false || videoSectionStatusChecker) && (deviceXs || deviceSm || deviceMd) && contentEditableBoolmin"
                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item (click)="toggleResPadLock($event)">
                        <mat-icon class = "mar-27px" [ngStyle]="isPrivate ? {'color': 'red'} : {}">
  {{ isPrivate ? 'lock' : 'lock_open' }}</mat-icon>
                        private
                    </button>
                    <button mat-menu-item class="body-font-size d-flex align-items-center menu-btn-alignment"
                        *ngIf="(pinDialogTriggered == false || videoSectionStatusChecker) && (deviceXs || deviceSm || deviceMd)"
                        (click)="openConfidentialDialog(minAttrList,minAttrList.entityType)">
                        <mat-icon class="mat-icon-menu"
                            matBadge="{{attachCount ? minAttrList.attachmentFileCount  : agendaAttachResp.attachmentFileCount}}"
                            matBadgeSize="medium" matBadgeColor="accent">file_upload</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">view / add file</h3>
                    </button>
                    <button mat-menu-item class="body-font-size d-flex align-items-center menu-btn-alignment"
                        *ngIf="(pinDialogTriggered == false || videoSectionStatusChecker) && (deviceXs || deviceSm || deviceMd)"
                        (click)="addNewLink(minAttrList.noteId,minAttrList.meetingId)">
                        <mat-icon class="mat-icon-menu"
                            matBadge="{{attachCount ? minAttrList.attachmentLinkCount  : agendaAttachResp.attachmentLinkCount}}"
                            matBadgeSize="medium" matBadgeColor="accent">add_link</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">view / add link</h3>
                    </button>
                    <button *ngIf="(pinDialogTriggered || videoSectionStatusChecker == false) && contentEditableBoolmin"
                        class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item (click)="toggleResPadLock($event)">
                        <mat-icon class = "mar-27px"  [ngStyle]="isPrivate ? {'color': 'red'} : {}">
  {{ isPrivate ? 'lock' : 'lock_open' }}</mat-icon>
                        private
                    </button>
                    <button class="body-font-size d-flex align-items-center menu-btn-alignment" mat-menu-item *ngIf="(pinDialogTriggered || videoSectionStatusChecker == false)"
                        (click)="openConfidentialDialog(minAttrList,minAttrList.entityType)">
                        <mat-icon class="mat-icon-menu"
                            matBadge="{{attachCount ? minAttrList.attachmentFileCount  : agendaAttachResp.attachmentFileCount}}"
                            matBadgeSize="medium" matBadgeColor="accent">file_upload</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">view / add file</h3>
                    </button>
                    <button class="body-font-size d-flex align-items-center menu-btn-alignment" mat-menu-item *ngIf="(pinDialogTriggered || videoSectionStatusChecker == false)"
                        (click)="addNewLink(minAttrList.noteId,minAttrList.meetingId)">
                        <mat-icon class="mat-icon-menu"
                            matBadge="{{attachCount ? minAttrList.attachmentLinkCount  : agendaAttachResp.attachmentLinkCount}}"
                            matBadgeSize="medium" matBadgeColor="accent">add_link</mat-icon>
                        <h3 class="mat-menu-content-alignment text-capitalize margin-0">view / add link</h3>
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
<mat-divider></mat-divider>
</mat-list-item>
